import { useAngemeldet } from "../../kern/sitzung";
import type { Zaehlerwert } from "../../kern/modul";
import { useAufgaben } from "./daten";
import { laufenderSprint, useSprints } from "./sprints";

/* Zähler in der Navigation (BAUPLAN-ABSCHLUSS.md, Abschnitt 4.4). Lesen dieselben Abfragen wie die Listen, aus dem Zwischenspeicher. */

const wert = (n: number, vorlesen: string, dringend = false): Zaehlerwert | null =>
  n > 0 ? { wert: String(n), vorlesen, ...(dringend ? { dringend } : {}) } : null;

/** Meine Woche: meine offenen im laufenden Sprint. Der einzige hervorgehobene Zähler (BAUPLAN-SEITENLEISTE.md, Abschnitt 3). */
export function useZaehlerWoche(): Zaehlerwert | null {
  const { person } = useAngemeldet();
  const aufgaben = useAufgaben();
  const laufend = laufenderSprint(useSprints().data);
  if (!laufend) return null;
  const n = (aufgaben.data ?? []).filter((a) => !a.eltern_id && a.sprint_id === laufend.id && a.status !== "erledigt" && a.personen.includes(person.id)).length;
  return wert(n, `${n} offen bei dir`, true);
}

/** Sprint: offene im laufenden Sprint */
export function useZaehlerSprint(): Zaehlerwert | null {
  const aufgaben = useAufgaben();
  const laufend = laufenderSprint(useSprints().data);
  if (!laufend) return null;
  const n = (aufgaben.data ?? []).filter((a) => !a.eltern_id && a.sprint_id === laufend.id && a.status !== "erledigt").length;
  return wert(n, `${n} offen im Sprint`);
}

/** Offen: ohne Verantwortliche, wie die Liste „Offen“ */
export function useZaehlerOffen(): Zaehlerwert | null {
  const aufgaben = useAufgaben();
  const n = (aufgaben.data ?? []).filter((a) => a.personen.length === 0 && a.status !== "erledigt" && a.sprint_status !== "abgeschlossen").length;
  return wert(n, `${n} ohne Person`);
}
